export default [
/*  {
    label: '订单管理',
    icon: 'icon-yonghu',
    permission:'order_manage',
    id:'5',
    children: [*/
      {
        label: '订单管理',
        icon: 'icon-zhangdan',
        path: '/order/manage',
        permission: 'order_manage',
        id:'5-1',
      },
      {
        label: '订单公海转移',
        icon: 'icon-zhangdan',
        path: '/order/quick-manage',
        permission: 'quick_manage',
        id:'5-2',
      }
   /* ],
  },*/
];
